<template>
  <div
    class="formField__Tooltip"
    :class="{ isClickOnly, isOpen, isArrowOnBottom: style.top !== 'auto' }"
    v-click-outside="() => close('click')"
    @click.prevent="show('click')"
    @mouseenter.prevent="show('hover')"
    @mouseleave.prevent="close('hover')"
  >
    <span class="formField__TooltipIcon" :class="{'customIcon': $slots.icon}" ref="tooltipIcon">
      <slot name="icon">
        <span>i</span>
      </slot>
    </span>
    <div v-if="text !== undefined || $slots['default']" class="formField__TooltipText" ref="tooltipText" :style="style">
      <div v-html="text" v-if="text" />
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      text: {},
      clickOnly: {}
    },

    setup(props) {
      let timeout = 0
      const isOpen = ref(false)
      const isClickOnly = toRefs(props).clickOnly
      const style = reactive({})
      const tooltipText = ref(null)
      const tooltipIcon = ref(null)
      const styleMap = reactive({
        left: '-8px',
        right: '-8px',
        top: 'calc(100% + 8px)',
        bottom: 'calc(100% + 8px)'
      })

      onMounted(() => {
        if (document.documentElement.clientWidth < 768) isClickOnly.value = true
        window.addEventListener('scroll', handleScroll)
      })

      onBeforeUnmount(() => {
        window.removeEventListener('scroll', handleScroll)
      })

      const handleScroll = () => {
        if (isOpen.value) {
          timeout = 0
          isOpen.value = false
        }
      }

      const show = type => {
        if (isClickOnly.value && type === 'click') isOpen.value = !isOpen.value
        if (!isClickOnly.value && type === 'hover') isOpen.value = true
        timeout = 0
      }

      const close = type => {
        if (type === 'click' || (!isClickOnly.value && type === 'hover')) isOpen.value = false
        timeout = 200
      }

      const setStyles = () => {
        const overflows = getOverflows(tooltipText.value)
        for (const key in overflows) {
          if (overflows[key]) style[key] = styleMap[key]
          else style[key] = 'auto'
        }

        if (document.documentElement.clientWidth > 768) {
          if (style.top === 'auto') style['bottom'] = 'calc(100% + 8px)'
          if (style.left === 'auto') style['right'] = '-8px'
        } else {
          style['top'] = `${getVerticalOffset()}px`
        }
      }

      const getOverflows = el => {
        const box = el.getBoundingClientRect()
        const out = {}
        out.top = box.top < 0
        out.left = box.left < 0
        out.bottom = box.bottom > (window.innerHeight || document.documentElement.clientHeight)
        out.right = box.right > (window.innerWidth || document.documentElement.clientWidth)
        out.any = out.top || out.left || out.bottom || out.right
        return out
      }

      const getVerticalOffset = () => {
        const box = tooltipIcon.value.getBoundingClientRect()
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        const clientTop = document.documentElement.clientTop || document.body.clientTop || 0
        return Math.round(box.top + scrollTop - clientTop - window.pageYOffset)
      }

      watch(isOpen, () => setTimeout(setStyles, timeout))

      return {
        isOpen,
        isClickOnly,
        style,
        tooltipText,
        tooltipIcon,

        show,
        close
      }
    }
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/components/forms/_tooltip.scss');
</style>
